import {useQuery} from "@apollo/client";
import React from "react";
import {FieldErrors, FormProvider, useForm} from "react-hook-form";

import {useCurrentUserContext} from "@/components/context/hooks.ts";
import FormErrorAlerts from "@/components/form/FormErrorAlerts.tsx";
import {ServiceField} from "@/lib/constants/service.ts";
import {GQL_GET_MONITORING_GROUPS, MonitoringGroups} from "@/lib/queries/checks.ts";
import {ServerErrors} from "@/lib/types/common.ts";
import {MonitoringGroupLevel, MonitoringGroupType} from "@/lib/types/monitoring.ts";
import {LocationsField} from "@/pages/checks/components/form/fields/LocationsField.tsx";
import {EditCheckLocationsFormValues} from "@/pages/checks/list/actions/bulkSetLocations/BulkSetLocationsModal.tsx";

export interface BulkSetLocationsFormProps {
  formId: string;
  onSubmit: (data: EditCheckLocationsFormValues) => void;
  onError?: (errors: FieldErrors<EditCheckLocationsFormValues>, event?: React.BaseSyntheticEvent) => void;
  serverErrors?: ServerErrors;
}

export const BulkSetLocationsForm = ({formId, onSubmit, onError, serverErrors}: BulkSetLocationsFormProps) => {
  const {data, loading, previousData} = useQuery<MonitoringGroups>(GQL_GET_MONITORING_GROUPS);
  const {user} = useCurrentUserContext();
  const methods = useForm<EditCheckLocationsFormValues>({
    defaultValues: {
      monitoring_groups: [],
    },
  });

  const currentData = loading ? previousData : data;
  const monitoringGroups = currentData?.monitoringGroups || [];
  const groupType = MonitoringGroupType.NORMAL;
  return (
    <FormProvider {...methods}>
      <form
        id={formId}
        onSubmit={(e) => {
          methods.handleSubmit(onSubmit, onError)(e);
        }}
      >
        {serverErrors?.monitoring_groups && <FormErrorAlerts errors={serverErrors?.monitoring_groups} />}
        <div className="mb-4">
          Note: Existing locations on selected Checks will be replaced with whatever you select below.
        </div>
        <LocationsField
          isMulti={true}
          required={true}
          disabled={false}
          monitoringGroups={monitoringGroups.filter((g) => g.type === groupType || g.is_private)}
          limit_monitoring_group_level={user?.account.limit_monitoring_group_level || MonitoringGroupLevel.LEVEL_0}
          limit_monitoring_groups={user?.account.limit_monitoring_groups}
          name={ServiceField.LOCATION}
          helpText={""}
          menuPortalTarget={
            (document.querySelector(`div.outlet-container > div.content-container`) as HTMLElement) ?? document.body
          }
          menuPosition={"fixed"}
        />
      </form>
    </FormProvider>
  );
};
